var _g, _g2, _g3, _g4, _mask, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 46,
    viewBox: "0 0 126 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 33.3208C45.8957 33.3208 45.8093 28.9504 45.8093 28.9504C45.8093 28.8496 45.8939 28.7686 46.0001 28.7686C46.1063 28.7686 46.1909 28.8496 46.1909 28.9504C46.1909 28.9504 46.1063 33.3208 46.0001 33.3208Z",
    fill: "url(#paint0_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1909 28.1818C46.1909 28.2826 46.1063 28.3636 46.0001 28.3636C45.8939 28.3636 45.8093 28.2826 45.8093 28.1818C45.8093 28.081 45.8939 28 46.0001 28C46.1063 28 46.1909 28.081 46.1909 28.1818Z",
    fill: "url(#paint1_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7283 34.0228C43.6437 34.0822 40.8753 30.5938 40.8753 30.5938C40.8141 30.5128 40.8321 30.3994 40.9167 30.34C41.0013 30.2806 41.1201 30.2986 41.1831 30.3796C41.1831 30.3796 43.8129 33.9634 43.7283 34.0228Z",
    fill: "url(#paint2_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7098 29.7585C40.771 29.8395 40.753 29.9529 40.6684 30.0123C40.5838 30.0717 40.465 30.0537 40.402 29.9727C40.3408 29.8917 40.3588 29.7783 40.4434 29.7189C40.528 29.6595 40.6468 29.6775 40.7098 29.7585Z",
    fill: "url(#paint3_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3245 35.8625C42.2921 35.9579 37.9001 34.6835 37.9001 34.6835C37.7993 34.6529 37.7453 34.5503 37.7777 34.4549C37.8101 34.3595 37.9181 34.3073 38.0171 34.3379C38.0171 34.3379 42.3569 35.7653 42.3245 35.8607V35.8625Z",
    fill: "url(#paint4_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2485 34.102C37.3493 34.1326 37.4033 34.2352 37.3709 34.3306C37.3385 34.426 37.2305 34.4782 37.1315 34.4476C37.0307 34.417 36.9767 34.3144 37.0091 34.219C37.0415 34.1236 37.1495 34.0714 37.2485 34.102Z",
    fill: "url(#paint5_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3245 38.1375C42.3569 38.2329 38.0171 39.6603 38.0171 39.6603C37.9163 39.6909 37.8101 39.6387 37.7777 39.5433C37.7453 39.4479 37.7993 39.3453 37.9001 39.3147C37.9001 39.3147 42.2921 38.0403 42.3245 38.1357V38.1375Z",
    fill: "url(#paint6_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1315 39.5522C37.2323 39.5216 37.3385 39.5738 37.3709 39.6692C37.4033 39.7646 37.3493 39.8672 37.2485 39.8978C37.1477 39.9284 37.0415 39.8762 37.0091 39.7808C36.9767 39.6854 37.0307 39.5828 37.1315 39.5522Z",
    fill: "url(#paint7_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7284 39.9773C43.813 40.0367 41.1832 43.6205 41.1832 43.6205C41.122 43.7015 41.0032 43.7195 40.9168 43.6601C40.8322 43.6007 40.8124 43.4873 40.8754 43.4063C40.8754 43.4063 43.642 39.9179 43.7284 39.9773Z",
    fill: "url(#paint8_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.402 44.0273C40.4632 43.9463 40.582 43.9283 40.6684 43.9877C40.753 44.0471 40.7728 44.1605 40.7098 44.2415C40.6486 44.3225 40.5298 44.3405 40.4434 44.2811C40.3588 44.2217 40.339 44.1083 40.402 44.0273Z",
    fill: "url(#paint9_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 40.6792C46.1045 40.6792 46.1909 45.0496 46.1909 45.0496C46.1909 45.1504 46.1063 45.2314 46.0001 45.2314C45.8939 45.2314 45.8093 45.1504 45.8093 45.0496C45.8093 45.0496 45.8939 40.6792 46.0001 40.6792Z",
    fill: "url(#paint10_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8093 45.8183C45.8093 45.7175 45.8939 45.6365 46.0001 45.6365C46.1063 45.6365 46.1909 45.7175 46.1909 45.8183C46.1909 45.9191 46.1063 46.0001 46.0001 46.0001C45.8939 46.0001 45.8093 45.9191 45.8093 45.8183Z",
    fill: "url(#paint11_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2718 39.9773C48.3564 39.9179 51.1248 43.4063 51.1248 43.4063C51.186 43.4873 51.168 43.6007 51.0834 43.6601C50.9988 43.7195 50.88 43.7015 50.817 43.6205C50.817 43.6205 48.1872 40.0367 48.2718 39.9773Z",
    fill: "url(#paint12_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2904 44.2415C51.2292 44.1605 51.2472 44.0471 51.3318 43.9877C51.4164 43.9283 51.5352 43.9463 51.5982 44.0273C51.6594 44.1083 51.6414 44.2217 51.5568 44.2811C51.4722 44.3405 51.3534 44.3225 51.2904 44.2415Z",
    fill: "url(#paint13_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6757 38.1377C49.7081 38.0423 54.1001 39.3167 54.1001 39.3167C54.2009 39.3473 54.2549 39.4499 54.2225 39.5453C54.1901 39.6407 54.0821 39.6929 53.9831 39.6623C53.9831 39.6623 49.6433 38.2349 49.6757 38.1395V38.1377Z",
    fill: "url(#paint14_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7517 39.8981C54.6509 39.8675 54.5969 39.7649 54.6293 39.6695C54.6617 39.5741 54.7697 39.5219 54.8687 39.5525C54.9677 39.5831 55.0235 39.6857 54.9911 39.7811C54.9587 39.8765 54.8507 39.9287 54.7517 39.8981Z",
    fill: "url(#paint15_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6757 35.8624C49.6433 35.767 53.9831 34.3396 53.9831 34.3396C54.0839 34.309 54.1901 34.3612 54.2225 34.4566C54.2549 34.552 54.2009 34.6546 54.1001 34.6852C54.1001 34.6852 49.7081 35.9596 49.6757 35.8642V35.8624Z",
    fill: "url(#paint16_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8687 34.4476C54.7679 34.4782 54.6617 34.426 54.6293 34.3306C54.5969 34.2352 54.6509 34.1326 54.7517 34.102C54.8525 34.0714 54.9587 34.1236 54.9911 34.219C55.0235 34.3144 54.9695 34.417 54.8687 34.4476Z",
    fill: "url(#paint17_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2718 34.0228C48.1872 33.9634 50.817 30.3796 50.817 30.3796C50.8782 30.2986 50.997 30.2806 51.0834 30.34C51.1698 30.3994 51.1878 30.5128 51.1248 30.5938C51.1248 30.5938 48.3582 34.0822 48.2718 34.0228Z",
    fill: "url(#paint18_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5982 29.9727C51.537 30.0537 51.4182 30.0717 51.3318 30.0123C51.2472 29.9529 51.2274 29.8395 51.2904 29.7585C51.3516 29.6775 51.4704 29.6595 51.5568 29.7189C51.6414 29.7783 51.6612 29.8917 51.5982 29.9727Z",
    fill: "url(#paint19_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4329 34.1075C47.3501 34.0697 48.2519 32.0861 48.2519 32.0861C48.2915 32.0069 48.3887 31.9745 48.4715 32.0105C48.5543 32.0483 48.5903 32.1419 48.5507 32.2193C48.5507 32.2193 47.5157 34.1435 47.4329 34.1057V34.1075Z",
    fill: "url(#paint20_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3736 33.8572C45.2836 33.8734 44.7886 31.7638 44.7886 31.7638C44.7724 31.6792 44.83 31.5964 44.92 31.5802C45.01 31.564 45.0964 31.6198 45.1126 31.7062C45.1126 31.7062 45.4636 33.8428 45.3736 33.859V33.8572Z",
    fill: "url(#paint21_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.552 34.8077C43.489 34.8707 41.7862 33.4415 41.7862 33.4415C41.7196 33.3821 41.716 33.2813 41.779 33.2183C41.842 33.1553 41.9464 33.1517 42.013 33.2111C42.013 33.2111 43.615 34.7429 43.552 34.8059V34.8077Z",
    fill: "url(#paint22_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6664 36.5967C42.6556 36.6831 40.393 36.4797 40.393 36.4797C40.303 36.4689 40.2382 36.3897 40.249 36.3033C40.2598 36.2169 40.3426 36.1557 40.4344 36.1665C40.4344 36.1665 42.6772 36.5085 42.6646 36.5949L42.6664 36.5967Z",
    fill: "url(#paint23_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0533 38.5389C43.0965 38.6145 41.1435 39.7161 41.1435 39.7161C41.0625 39.7575 40.9635 39.7305 40.9185 39.6531C40.8753 39.5775 40.9041 39.4803 40.9833 39.4389C40.9833 39.4389 43.0083 38.4615 43.0533 38.5371V38.5389Z",
    fill: "url(#paint24_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5673 39.8926C44.6501 39.9304 43.7483 41.914 43.7483 41.914C43.7087 41.9932 43.6115 42.0256 43.5287 41.9896C43.4459 41.9518 43.4099 41.8582 43.4495 41.7808C43.4495 41.7808 44.4845 39.8566 44.5673 39.8944V39.8926Z",
    fill: "url(#paint25_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6263 40.1427C46.7163 40.1265 47.2113 42.2361 47.2113 42.2361C47.2275 42.3207 47.1699 42.4035 47.0799 42.4197C46.9899 42.4359 46.9035 42.3801 46.8873 42.2937C46.8873 42.2937 46.5363 40.1571 46.6263 40.1409V40.1427Z",
    fill: "url(#paint26_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4481 39.1925C48.5111 39.1295 50.2139 40.5587 50.2139 40.5587C50.2805 40.6181 50.2841 40.7189 50.2211 40.7819C50.1581 40.8449 50.0537 40.8485 49.9871 40.7891C49.9871 40.7891 48.3851 39.2573 48.4481 39.1943V39.1925Z",
    fill: "url(#paint27_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3335 37.4032C49.3443 37.3168 51.6069 37.5202 51.6069 37.5202C51.6969 37.531 51.7617 37.6102 51.7509 37.6966C51.7401 37.783 51.6573 37.8442 51.5655 37.8334C51.5655 37.8334 49.3227 37.4914 49.3353 37.405L49.3335 37.4032Z",
    fill: "url(#paint28_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9465 35.4609C48.9033 35.3853 50.8563 34.2837 50.8563 34.2837C50.9373 34.2423 51.0363 34.2693 51.0813 34.3467C51.1245 34.4223 51.0957 34.5195 51.0165 34.5609C51.0165 34.5609 48.9915 35.5383 48.9465 35.4627V35.4609Z",
    fill: "url(#paint29_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4111 30.7972C47.3085 30.7756 47.4417 29.8018 47.4417 29.8018C47.4633 29.7046 47.5659 29.6416 47.6685 29.6632C47.7711 29.6848 47.8359 29.7802 47.8143 29.8792C47.8143 29.8792 47.5137 30.8188 47.4111 30.7972Z",
    fill: "url(#paint30_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3107 31.1932C43.2153 31.2328 42.7221 30.3706 42.7221 30.3706C42.6789 30.2788 42.7221 30.1726 42.8193 30.1312C42.9147 30.0916 43.0281 30.1312 43.0695 30.2248C43.0695 30.2248 43.4061 31.1536 43.3107 31.1932Z",
    fill: "url(#paint31_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2399 33.8067C40.1877 33.8931 39.2553 33.4701 39.2553 33.4701C39.1653 33.4197 39.1329 33.3081 39.1869 33.2217C39.2391 33.1353 39.3561 33.1065 39.4479 33.1569C39.4479 33.1569 40.2939 33.7185 40.2399 33.8067Z",
    fill: "url(#paint32_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.367 37.6389C39.3778 37.7379 38.3644 37.9179 38.3644 37.9179C38.26 37.9287 38.1664 37.8549 38.1556 37.7559C38.1448 37.6569 38.2204 37.5669 38.3266 37.5579C38.3266 37.5579 39.358 37.5399 39.3688 37.6389H39.367Z",
    fill: "url(#paint33_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0301 41.2281C41.1003 41.3019 40.3911 42.0147 40.3911 42.0147C40.3119 42.0813 40.1931 42.0741 40.1229 42.0003C40.0527 41.9265 40.0599 41.8113 40.1373 41.7447C40.1373 41.7447 40.9599 41.1525 41.0301 41.2281Z",
    fill: "url(#paint34_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5887 43.2028C44.6913 43.2244 44.5581 44.1982 44.5581 44.1982C44.5365 44.2954 44.4339 44.3584 44.3313 44.3368C44.2287 44.3152 44.1639 44.2198 44.1855 44.1208C44.1855 44.1208 44.4861 43.1812 44.5887 43.2028Z",
    fill: "url(#paint35_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6891 42.8067C48.7845 42.7671 49.2777 43.6293 49.2777 43.6293C49.3209 43.7211 49.2777 43.8273 49.1805 43.8687C49.0851 43.9083 48.9717 43.8687 48.9303 43.7751C48.9303 43.7751 48.5937 42.8463 48.6891 42.8067Z",
    fill: "url(#paint36_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.76 40.1933C51.8122 40.1069 52.7446 40.5299 52.7446 40.5299C52.8346 40.5803 52.867 40.6919 52.813 40.7783C52.759 40.8647 52.6438 40.8935 52.552 40.8431C52.552 40.8431 51.706 40.2815 51.76 40.1933Z",
    fill: "url(#paint37_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6329 36.3611C52.6221 36.2621 53.6355 36.0821 53.6355 36.0821C53.7399 36.0713 53.8335 36.1451 53.8443 36.2441C53.8551 36.3431 53.7795 36.4331 53.6733 36.4421C53.6733 36.4421 52.6419 36.4601 52.6311 36.3611H52.6329Z",
    fill: "url(#paint38_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9697 32.7718C50.8995 32.698 51.6087 31.9852 51.6087 31.9852C51.6879 31.9186 51.8067 31.9258 51.8769 31.9996C51.9471 32.0734 51.9399 32.1886 51.8625 32.2552C51.8625 32.2552 51.0399 32.8474 50.9697 32.7718Z",
    fill: "url(#paint39_radial_2002_200)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2002_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 5.32075C77.8957 5.32075 77.8093 0.950355 77.8093 0.950355C77.8093 0.849555 77.8939 0.768555 78.0001 0.768555C78.1063 0.768555 78.1909 0.849555 78.1909 0.950355C78.1909 0.950355 78.1063 5.32075 78.0001 5.32075Z",
    fill: "url(#paint40_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1909 0.1818C78.1909 0.2826 78.1063 0.3636 78.0001 0.3636C77.8939 0.3636 77.8093 0.2826 77.8093 0.1818C77.8093 0.081 77.8939 0 78.0001 0C78.1063 0 78.1909 0.081 78.1909 0.1818Z",
    fill: "url(#paint41_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7283 6.02278C75.6437 6.08218 72.8753 2.59378 72.8753 2.59378C72.8141 2.51278 72.8321 2.39938 72.9167 2.33998C73.0013 2.28058 73.1201 2.29858 73.1831 2.37958C73.1831 2.37958 75.8129 5.96338 75.7283 6.02278Z",
    fill: "url(#paint42_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7098 1.75849C72.771 1.83949 72.753 1.95289 72.6684 2.01229C72.5838 2.07169 72.465 2.05369 72.402 1.97269C72.3408 1.89169 72.3588 1.77829 72.4434 1.71889C72.528 1.65949 72.6468 1.67749 72.7098 1.75849Z",
    fill: "url(#paint43_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3245 7.86245C74.2921 7.95785 69.9001 6.68345 69.9001 6.68345C69.7993 6.65285 69.7453 6.55025 69.7777 6.45485C69.8101 6.35945 69.9181 6.30725 70.0171 6.33785C70.0171 6.33785 74.3569 7.76525 74.3245 7.86065V7.86245Z",
    fill: "url(#paint44_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2485 6.10201C69.3493 6.13261 69.4033 6.23521 69.3709 6.33061C69.3385 6.42601 69.2305 6.47821 69.1315 6.44761C69.0307 6.41701 68.9767 6.31441 69.0091 6.21901C69.0415 6.12361 69.1495 6.07141 69.2485 6.10201Z",
    fill: "url(#paint45_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3245 10.1375C74.3569 10.2329 70.0171 11.6603 70.0171 11.6603C69.9163 11.6909 69.8101 11.6387 69.7777 11.5433C69.7453 11.4479 69.7993 11.3453 69.9001 11.3147C69.9001 11.3147 74.2921 10.0403 74.3245 10.1357V10.1375Z",
    fill: "url(#paint46_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1315 11.5522C69.2323 11.5216 69.3385 11.5738 69.3709 11.6692C69.4033 11.7646 69.3493 11.8672 69.2485 11.8978C69.1477 11.9284 69.0415 11.8762 69.0091 11.7808C68.9767 11.6854 69.0307 11.5828 69.1315 11.5522Z",
    fill: "url(#paint47_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7284 11.9773C75.813 12.0367 73.1832 15.6205 73.1832 15.6205C73.122 15.7015 73.0032 15.7195 72.9168 15.6601C72.8322 15.6007 72.8124 15.4873 72.8754 15.4063C72.8754 15.4063 75.642 11.9179 75.7284 11.9773Z",
    fill: "url(#paint48_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.402 16.0273C72.4632 15.9463 72.582 15.9283 72.6684 15.9877C72.753 16.0471 72.7728 16.1605 72.7098 16.2415C72.6486 16.3225 72.5298 16.3405 72.4434 16.2811C72.3588 16.2217 72.339 16.1083 72.402 16.0273Z",
    fill: "url(#paint49_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 12.6792C78.1045 12.6792 78.1909 17.0496 78.1909 17.0496C78.1909 17.1504 78.1063 17.2314 78.0001 17.2314C77.8939 17.2314 77.8093 17.1504 77.8093 17.0496C77.8093 17.0496 77.8939 12.6792 78.0001 12.6792Z",
    fill: "url(#paint50_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8093 17.8183C77.8093 17.7175 77.8939 17.6365 78.0001 17.6365C78.1063 17.6365 78.1909 17.7175 78.1909 17.8183C78.1909 17.9191 78.1063 18.0001 78.0001 18.0001C77.8939 18.0001 77.8093 17.9191 77.8093 17.8183Z",
    fill: "url(#paint51_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2718 11.9773C80.3564 11.9179 83.1248 15.4063 83.1248 15.4063C83.186 15.4873 83.168 15.6007 83.0834 15.6601C82.9988 15.7195 82.88 15.7015 82.817 15.6205C82.817 15.6205 80.1872 12.0367 80.2718 11.9773Z",
    fill: "url(#paint52_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2904 16.2415C83.2292 16.1605 83.2472 16.0471 83.3318 15.9877C83.4164 15.9283 83.5352 15.9463 83.5982 16.0273C83.6594 16.1083 83.6414 16.2217 83.5568 16.2811C83.4722 16.3405 83.3534 16.3225 83.2904 16.2415Z",
    fill: "url(#paint53_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6757 10.1377C81.7081 10.0423 86.1001 11.3167 86.1001 11.3167C86.2009 11.3473 86.2549 11.4499 86.2225 11.5453C86.1901 11.6407 86.0821 11.6929 85.9831 11.6623C85.9831 11.6623 81.6433 10.2349 81.6757 10.1395V10.1377Z",
    fill: "url(#paint54_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7517 11.8981C86.6509 11.8675 86.5969 11.7649 86.6293 11.6695C86.6617 11.5741 86.7697 11.5219 86.8687 11.5525C86.9677 11.5831 87.0235 11.6857 86.9911 11.7811C86.9587 11.8765 86.8507 11.9287 86.7517 11.8981Z",
    fill: "url(#paint55_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6757 7.86236C81.6433 7.76696 85.9831 6.33956 85.9831 6.33956C86.0839 6.30896 86.1901 6.36116 86.2225 6.45656C86.2549 6.55196 86.2009 6.65456 86.1001 6.68516C86.1001 6.68516 81.7081 7.95956 81.6757 7.86416V7.86236Z",
    fill: "url(#paint56_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8687 6.44761C86.7679 6.47821 86.6617 6.42601 86.6293 6.33061C86.5969 6.23521 86.6509 6.13261 86.7517 6.10201C86.8525 6.07141 86.9587 6.12361 86.9911 6.21901C87.0235 6.31441 86.9695 6.41701 86.8687 6.44761Z",
    fill: "url(#paint57_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2718 6.02278C80.1872 5.96338 82.817 2.37958 82.817 2.37958C82.8782 2.29858 82.997 2.28058 83.0834 2.33998C83.1698 2.39938 83.1878 2.51278 83.1248 2.59378C83.1248 2.59378 80.3582 6.08218 80.2718 6.02278Z",
    fill: "url(#paint58_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5982 1.97269C83.537 2.05369 83.4182 2.07169 83.3318 2.01229C83.2472 1.95289 83.2274 1.83949 83.2904 1.75849C83.3516 1.67749 83.4704 1.65949 83.5568 1.71889C83.6414 1.77829 83.6612 1.89169 83.5982 1.97269Z",
    fill: "url(#paint59_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4329 6.10748C79.3501 6.06968 80.2519 4.08608 80.2519 4.08608C80.2915 4.00688 80.3887 3.97448 80.4715 4.01048C80.5543 4.04828 80.5903 4.14188 80.5507 4.21928C80.5507 4.21928 79.5157 6.14348 79.4329 6.10568V6.10748Z",
    fill: "url(#paint60_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3736 5.85719C77.2836 5.87339 76.7886 3.76379 76.7886 3.76379C76.7724 3.67919 76.83 3.59639 76.92 3.58019C77.01 3.56399 77.0964 3.61979 77.1126 3.70619C77.1126 3.70619 77.4636 5.84279 77.3736 5.85899V5.85719Z",
    fill: "url(#paint61_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.552 6.80769C75.489 6.87069 73.7862 5.44149 73.7862 5.44149C73.7196 5.38209 73.716 5.28129 73.779 5.21829C73.842 5.15529 73.9464 5.15169 74.013 5.21109C74.013 5.21109 75.615 6.74289 75.552 6.80589V6.80769Z",
    fill: "url(#paint62_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6664 8.59672C74.6556 8.68312 72.393 8.47972 72.393 8.47972C72.303 8.46892 72.2382 8.38972 72.249 8.30332C72.2598 8.21692 72.3426 8.15572 72.4344 8.16652C72.4344 8.16652 74.6772 8.50852 74.6646 8.59492L74.6664 8.59672Z",
    fill: "url(#paint63_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0533 10.5389C75.0965 10.6145 73.1435 11.7161 73.1435 11.7161C73.0625 11.7575 72.9635 11.7305 72.9185 11.6531C72.8753 11.5775 72.9041 11.4803 72.9833 11.4389C72.9833 11.4389 75.0083 10.4615 75.0533 10.5371V10.5389Z",
    fill: "url(#paint64_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5673 11.8926C76.6501 11.9304 75.7483 13.914 75.7483 13.914C75.7087 13.9932 75.6115 14.0256 75.5287 13.9896C75.4459 13.9518 75.4099 13.8582 75.4495 13.7808C75.4495 13.7808 76.4845 11.8566 76.5673 11.8944V11.8926Z",
    fill: "url(#paint65_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6263 12.1427C78.7163 12.1265 79.2113 14.2361 79.2113 14.2361C79.2275 14.3207 79.1699 14.4035 79.0799 14.4197C78.9899 14.4359 78.9035 14.3801 78.8873 14.2937C78.8873 14.2937 78.5363 12.1571 78.6263 12.1409V12.1427Z",
    fill: "url(#paint66_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4481 11.1925C80.5111 11.1295 82.2139 12.5587 82.2139 12.5587C82.2805 12.6181 82.2841 12.7189 82.2211 12.7819C82.1581 12.8449 82.0537 12.8485 81.9871 12.7891C81.9871 12.7891 80.3851 11.2573 80.4481 11.1943V11.1925Z",
    fill: "url(#paint67_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3335 9.40321C81.3443 9.31681 83.6069 9.52021 83.6069 9.52021C83.6969 9.53101 83.7617 9.61021 83.7509 9.69661C83.7401 9.78301 83.6573 9.84421 83.5655 9.83341C83.5655 9.83341 81.3227 9.49141 81.3353 9.40501L81.3335 9.40321Z",
    fill: "url(#paint68_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9465 7.46093C80.9033 7.38533 82.8563 6.28373 82.8563 6.28373C82.9373 6.24233 83.0363 6.26933 83.0813 6.34673C83.1245 6.42233 83.0957 6.51953 83.0165 6.56093C83.0165 6.56093 80.9915 7.53833 80.9465 7.46273V7.46093Z",
    fill: "url(#paint69_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4111 2.79718C79.3085 2.77558 79.4417 1.80178 79.4417 1.80178C79.4633 1.70458 79.5659 1.64158 79.6685 1.66318C79.7711 1.68478 79.8359 1.78018 79.8143 1.87918C79.8143 1.87918 79.5137 2.81878 79.4111 2.79718Z",
    fill: "url(#paint70_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3107 3.19324C75.2153 3.23284 74.7221 2.37064 74.7221 2.37064C74.6789 2.27884 74.7221 2.17264 74.8193 2.13124C74.9147 2.09164 75.0281 2.13124 75.0695 2.22484C75.0695 2.22484 75.4061 3.15364 75.3107 3.19324Z",
    fill: "url(#paint71_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2399 5.80668C72.1877 5.89308 71.2553 5.47008 71.2553 5.47008C71.1653 5.41968 71.1329 5.30808 71.1869 5.22168C71.2391 5.13528 71.3561 5.10648 71.4479 5.15688C71.4479 5.15688 72.2939 5.71848 72.2399 5.80668Z",
    fill: "url(#paint72_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.367 9.63892C71.3778 9.73792 70.3644 9.91792 70.3644 9.91792C70.26 9.92872 70.1664 9.85492 70.1556 9.75592C70.1448 9.65692 70.2204 9.56692 70.3266 9.55792C70.3266 9.55792 71.358 9.53992 71.3688 9.63892H71.367Z",
    fill: "url(#paint73_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0301 13.2281C73.1003 13.3019 72.3911 14.0147 72.3911 14.0147C72.3119 14.0813 72.1931 14.0741 72.1229 14.0003C72.0527 13.9265 72.0599 13.8113 72.1373 13.7447C72.1373 13.7447 72.9599 13.1525 73.0301 13.2281Z",
    fill: "url(#paint74_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5887 15.2028C76.6913 15.2244 76.5581 16.1982 76.5581 16.1982C76.5365 16.2954 76.4339 16.3584 76.3313 16.3368C76.2287 16.3152 76.1639 16.2198 76.1855 16.1208C76.1855 16.1208 76.4861 15.1812 76.5887 15.2028Z",
    fill: "url(#paint75_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6891 14.8067C80.7845 14.7671 81.2777 15.6293 81.2777 15.6293C81.3209 15.7211 81.2777 15.8273 81.1805 15.8687C81.0851 15.9083 80.9717 15.8687 80.9303 15.7751C80.9303 15.7751 80.5937 14.8463 80.6891 14.8067Z",
    fill: "url(#paint76_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.76 12.1933C83.8122 12.1069 84.7446 12.5299 84.7446 12.5299C84.8346 12.5803 84.867 12.6919 84.813 12.7783C84.759 12.8647 84.6438 12.8935 84.552 12.8431C84.552 12.8431 83.706 12.2815 83.76 12.1933Z",
    fill: "url(#paint77_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6329 8.3611C84.6221 8.2621 85.6355 8.0821 85.6355 8.0821C85.7399 8.0713 85.8335 8.1451 85.8443 8.2441C85.8551 8.3431 85.7795 8.4331 85.6733 8.4421C85.6733 8.4421 84.6419 8.4601 84.6311 8.3611H84.6329Z",
    fill: "url(#paint78_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9697 4.77181C82.8995 4.69801 83.6087 3.98521 83.6087 3.98521C83.6879 3.91861 83.8067 3.92581 83.8769 3.99961C83.9471 4.07341 83.9399 4.18861 83.8625 4.25521C83.8625 4.25521 83.0399 4.84741 82.9697 4.77181Z",
    fill: "url(#paint79_radial_2002_200)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2002_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 12.3409C14.3765 12.3409 14.2751 10.576 14.2751 10.576C14.2751 10.4524 14.3753 10.3511 14.5001 10.3511C14.6249 10.3511 14.725 10.4512 14.725 10.576C14.725 10.576 14.6249 12.3409 14.5001 12.3409Z",
    fill: "url(#paint80_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4211 12.63C13.3136 12.6918 12.3446 11.2137 12.3446 11.2137C12.2828 11.1061 12.3199 10.9689 12.4262 10.9071C12.5325 10.8453 12.6709 10.8824 12.7327 10.9887C12.7327 10.9887 13.5287 12.5682 13.4211 12.63Z",
    fill: "url(#paint81_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6301 13.4212C12.5683 13.5288 10.9888 12.7328 10.9888 12.7328C10.8813 12.671 10.8442 12.5338 10.9072 12.4263C10.9703 12.3188 11.1062 12.2817 11.2137 12.3447C11.2137 12.3447 12.6919 13.3149 12.6301 13.4212Z",
    fill: "url(#paint82_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3409 14.5001C12.3409 14.6237 10.576 14.725 10.576 14.725C10.4524 14.725 10.3511 14.6249 10.3511 14.5001C10.3511 14.3753 10.4512 14.2751 10.576 14.2751C10.576 14.2751 12.3409 14.3753 12.3409 14.5001Z",
    fill: "url(#paint83_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.63 15.5803C12.6918 15.6878 11.2137 16.6568 11.2137 16.6568C11.1061 16.7186 10.9689 16.6815 10.9071 16.5752C10.8453 16.4677 10.8824 16.3305 10.9887 16.2687C10.9887 16.2687 12.5682 15.4728 12.63 15.5803Z",
    fill: "url(#paint84_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4212 16.37C13.5288 16.4318 12.7328 18.0114 12.7328 18.0114C12.671 18.1189 12.5338 18.156 12.4263 18.0929C12.3188 18.0299 12.2817 17.894 12.3447 17.7864C12.3447 17.7864 13.3149 16.3083 13.4212 16.37Z",
    fill: "url(#paint85_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 16.6606C14.6237 16.6606 14.725 18.4256 14.725 18.4256C14.725 18.5492 14.6249 18.6505 14.5001 18.6505C14.3753 18.6505 14.2751 18.5504 14.2751 18.4256C14.2751 18.4256 14.3753 16.6606 14.5001 16.6606Z",
    fill: "url(#paint86_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5803 16.37C15.6878 16.3083 16.6568 17.7864 16.6568 17.7864C16.7186 17.894 16.6815 18.0311 16.5752 18.0929C16.4677 18.1547 16.3305 18.1177 16.2687 18.0114C16.2687 18.0114 15.4728 16.4318 15.5803 16.37Z",
    fill: "url(#paint87_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 15.5803C16.4318 15.4728 18.0114 16.2687 18.0114 16.2687C18.1189 16.3305 18.156 16.4677 18.0929 16.5752C18.0311 16.6828 17.894 16.7198 17.7864 16.6568C17.7864 16.6568 16.3083 15.6866 16.37 15.5803Z",
    fill: "url(#paint88_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6606 14.5001C16.6606 14.3765 18.4256 14.2751 18.4256 14.2751C18.5492 14.2751 18.6505 14.3753 18.6505 14.5001C18.6505 14.6249 18.5504 14.725 18.4256 14.725C18.4256 14.725 16.6606 14.6249 16.6606 14.5001Z",
    fill: "url(#paint89_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 13.4211C16.3083 13.3136 17.7864 12.3446 17.7864 12.3446C17.894 12.2828 18.0311 12.3199 18.0929 12.4262C18.1547 12.5337 18.1177 12.6709 18.0114 12.7327C18.0114 12.7327 16.4318 13.5287 16.37 13.4211Z",
    fill: "url(#paint90_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5803 12.6301C15.4728 12.5683 16.2687 10.9888 16.2687 10.9888C16.3305 10.8813 16.4677 10.8442 16.5752 10.9072C16.6828 10.969 16.7198 11.1062 16.6568 11.2137C16.6568 11.2137 15.6866 12.6919 15.5803 12.6301Z",
    fill: "url(#paint91_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1735 12.0591C15.0339 12.0208 16.6183 5.83121 16.6183 5.83121C16.6566 5.69155 16.8012 5.60874 16.9421 5.64706C17.0818 5.68537 17.1646 5.82998 17.1263 5.97087C17.1263 5.97087 15.3144 12.0974 15.1735 12.0591Z",
    fill: "url(#paint92_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8634 12.0504C13.7225 12.0875 12.0009 5.935 12.0009 5.935C11.9638 5.79411 12.0491 5.65074 12.1887 5.61366C12.3296 5.57658 12.473 5.66186 12.5101 5.80152C12.5101 5.80152 14.0043 12.0133 13.8634 12.0504Z",
    fill: "url(#paint93_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7228 12.6968C12.619 12.7994 8.05225 8.33149 8.05225 8.33149C7.94966 8.22767 7.9509 8.06205 8.05472 7.95947C8.15854 7.85689 8.32415 7.85812 8.42673 7.96194C8.42673 7.96194 12.8267 12.5942 12.7228 12.6968Z",
    fill: "url(#paint94_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0591 13.8264C12.0208 13.9661 5.83121 12.3816 5.83121 12.3816C5.69155 12.3433 5.60874 12.1987 5.64706 12.0578C5.68537 11.9181 5.82998 11.8353 5.97087 11.8736C5.97087 11.8736 12.0974 13.6855 12.0591 13.8264Z",
    fill: "url(#paint95_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0504 15.1378C12.0875 15.2787 5.935 17.0003 5.935 17.0003C5.79411 17.0374 5.65074 16.9521 5.61366 16.8125C5.57658 16.6716 5.66186 16.5282 5.80152 16.4911C5.80152 16.4911 12.0133 14.9969 12.0504 15.1378Z",
    fill: "url(#paint96_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6968 16.2772C12.7994 16.381 8.33149 20.9478 8.33149 20.9478C8.22767 21.0504 8.06205 21.0491 7.95947 20.9453C7.85689 20.8415 7.85812 20.6759 7.96194 20.5733C7.96194 20.5733 12.5942 16.1734 12.6968 16.2772Z",
    fill: "url(#paint97_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8264 16.9411C13.9661 16.9794 12.3816 23.169 12.3816 23.169C12.3433 23.3086 12.1987 23.3914 12.0578 23.3531C11.9181 23.3148 11.8353 23.1702 11.8736 23.0293C11.8736 23.0293 13.6855 16.9028 13.8264 16.9411Z",
    fill: "url(#paint98_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1378 16.9509C15.2787 16.9138 17.0003 23.0663 17.0003 23.0663C17.0374 23.2072 16.9521 23.3505 16.8125 23.3876C16.6728 23.4247 16.5282 23.3394 16.4911 23.1997C16.4911 23.1997 14.9969 16.9879 15.1378 16.9509Z",
    fill: "url(#paint99_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2772 16.3033C16.381 16.2007 20.9478 20.6686 20.9478 20.6686C21.0504 20.7724 21.0491 20.938 20.9453 21.0406C20.8415 21.1432 20.6759 21.1419 20.5733 21.0381C20.5733 21.0381 16.1734 16.4058 16.2772 16.3033Z",
    fill: "url(#paint100_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9411 15.1735C16.9794 15.0339 23.169 16.6183 23.169 16.6183C23.3086 16.6566 23.3914 16.8012 23.3531 16.9421C23.3148 17.083 23.1702 17.1646 23.0293 17.1263C23.0293 17.1263 16.9028 15.3144 16.9411 15.1735Z",
    fill: "url(#paint101_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9509 13.8634C16.9138 13.7225 23.0663 12.0009 23.0663 12.0009C23.2072 11.9638 23.3505 12.0491 23.3876 12.1887C23.4247 12.3296 23.3394 12.473 23.1997 12.5101C23.1997 12.5101 16.9879 14.0043 16.9509 13.8634Z",
    fill: "url(#paint102_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3033 12.7228C16.2007 12.619 20.6686 8.05225 20.6686 8.05225C20.7724 7.94966 20.938 7.9509 21.0406 8.05472C21.1432 8.15854 21.1419 8.32415 21.0381 8.42673C21.0381 8.42673 16.4058 12.8267 16.3033 12.7228Z",
    fill: "url(#paint103_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 9.67614C14.3765 9.67614 14.2751 0.22494 14.2751 0.22494C14.2751 0.101347 14.3753 0 14.5001 0C14.6249 0 14.725 0.100111 14.725 0.22494C14.725 0.22494 14.6249 9.67614 14.5001 9.67614Z",
    fill: "url(#paint104_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0886 10.3224C11.9811 10.3842 7.16837 2.2493 7.16837 2.2493C7.10657 2.14177 7.14365 2.00458 7.24994 1.94278C7.35747 1.88099 7.49466 1.91807 7.55645 2.02436C7.55645 2.02436 12.1949 10.2594 12.0874 10.3224H12.0886Z",
    fill: "url(#paint105_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3225 12.0887C10.2607 12.1962 2.02444 7.55776 2.02444 7.55776C1.91692 7.49597 1.87984 7.35878 1.94287 7.25125C2.00467 7.14372 2.14186 7.10665 2.24938 7.16968C2.24938 7.16968 10.3843 11.9824 10.3225 12.0899V12.0887Z",
    fill: "url(#paint106_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67614 14.5001C9.67614 14.6237 0.22494 14.725 0.22494 14.725C0.101347 14.725 0 14.6249 0 14.5001C0 14.3753 0.100111 14.2751 0.22494 14.2751C0.22494 14.2751 9.67614 14.3753 9.67614 14.5001Z",
    fill: "url(#paint107_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3224 16.9125C10.3842 17.02 2.2493 21.8327 2.2493 21.8327C2.14177 21.8945 2.00458 21.8575 1.94278 21.7512C1.88099 21.6436 1.91807 21.5064 2.02436 21.4446C2.02436 21.4446 10.2594 16.8062 10.3224 16.9137V16.9125Z",
    fill: "url(#paint108_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0887 18.6788C12.1962 18.7406 7.55776 26.9769 7.55776 26.9769C7.49597 27.0844 7.35878 27.1215 7.25125 27.0585C7.14372 26.9954 7.10665 26.8595 7.16968 26.7519C7.16968 26.7519 11.9824 18.617 12.0899 18.6788H12.0887Z",
    fill: "url(#paint109_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 19.3252C14.6237 19.3252 14.725 28.7764 14.725 28.7764C14.725 28.9 14.6249 29.0013 14.5001 29.0013C14.3753 29.0013 14.2751 28.9012 14.2751 28.7764C14.2751 28.7764 14.3753 19.3252 14.5001 19.3252Z",
    fill: "url(#paint110_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9125 18.6788C17.02 18.617 21.8327 26.752 21.8327 26.752C21.8945 26.8595 21.8575 26.9967 21.7512 27.0585C21.6436 27.1203 21.5064 27.0832 21.4446 26.9769C21.4446 26.9769 16.8062 18.7418 16.9137 18.6788H16.9125Z",
    fill: "url(#paint111_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6788 16.9125C18.7406 16.805 26.9769 21.4434 26.9769 21.4434C27.0844 21.5052 27.1215 21.6424 27.0585 21.7499C26.9967 21.8575 26.8595 21.8945 26.7519 21.8315C26.7519 21.8315 18.617 17.0188 18.6788 16.9113V16.9125Z",
    fill: "url(#paint112_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3252 14.5001C19.3252 14.3765 28.7764 14.2751 28.7764 14.2751C28.9 14.2751 29.0013 14.3753 29.0013 14.5001C29.0013 14.6249 28.9012 14.725 28.7764 14.725C28.7764 14.725 19.3252 14.6249 19.3252 14.5001Z",
    fill: "url(#paint113_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6788 12.0886C18.617 11.9811 26.752 7.16837 26.752 7.16837C26.8595 7.10657 26.9967 7.14365 27.0585 7.24994C27.1203 7.35747 27.0832 7.49466 26.9769 7.55645C26.9769 7.55645 18.7418 12.1949 18.6788 12.0874V12.0886Z",
    fill: "url(#paint114_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9125 10.3225C16.805 10.2607 21.4434 2.02444 21.4434 2.02444C21.5052 1.91692 21.6424 1.87984 21.7499 1.94287C21.8575 2.00467 21.8945 2.14186 21.8315 2.24938C21.8315 2.24938 17.0188 10.3843 16.9113 10.3225H16.9125Z",
    fill: "url(#paint115_radial_2002_200)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2002_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.5 29.6387C113.394 29.6387 113.306 28.1173 113.306 28.1173C113.306 28.0107 113.392 27.9233 113.5 27.9233C113.608 27.9233 113.694 28.0096 113.694 28.1173C113.694 28.1173 113.608 29.6387 113.5 29.6387Z",
    fill: "url(#paint116_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57 29.888C112.477 29.9413 111.642 28.667 111.642 28.667C111.589 28.5743 111.621 28.456 111.712 28.4028C111.804 28.3495 111.923 28.3815 111.977 28.4731C111.977 28.4731 112.663 29.8347 112.57 29.888Z",
    fill: "url(#paint117_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.888 30.57C111.835 30.6627 110.473 29.9766 110.473 29.9766C110.38 29.9233 110.348 29.805 110.403 29.7123C110.457 29.6196 110.574 29.5877 110.667 29.642C110.667 29.642 111.941 30.4784 111.888 30.57Z",
    fill: "url(#paint118_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.639 31.5001C111.639 31.6066 110.117 31.694 110.117 31.694C110.011 31.694 109.923 31.6077 109.923 31.5001C109.923 31.3925 110.01 31.3062 110.117 31.3062C110.117 31.3062 111.639 31.3925 111.639 31.5001Z",
    fill: "url(#paint119_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.888 32.4312C111.941 32.5239 110.667 33.3592 110.667 33.3592C110.574 33.4125 110.456 33.3805 110.403 33.2889C110.349 33.1962 110.381 33.078 110.473 33.0247C110.473 33.0247 111.835 32.3385 111.888 32.4312Z",
    fill: "url(#paint120_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57 33.1122C112.663 33.1655 111.977 34.5272 111.977 34.5272C111.923 34.6198 111.805 34.6518 111.712 34.5975C111.62 34.5431 111.588 34.4259 111.642 34.3332C111.642 34.3332 112.478 33.0589 112.57 33.1122Z",
    fill: "url(#paint121_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 33.3625C113.607 33.3625 113.694 34.884 113.694 34.884C113.694 34.9906 113.608 35.0779 113.5 35.0779C113.392 35.0779 113.306 34.9916 113.306 34.884C113.306 34.884 113.392 33.3625 113.5 33.3625Z",
    fill: "url(#paint122_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.431 33.1122C114.524 33.0589 115.359 34.3332 115.359 34.3332C115.413 34.4259 115.381 34.5442 115.289 34.5975C115.196 34.6507 115.078 34.6188 115.025 34.5272C115.025 34.5272 114.339 33.1655 114.431 33.1122Z",
    fill: "url(#paint123_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.112 32.4312C115.165 32.3385 116.527 33.0247 116.527 33.0247C116.62 33.078 116.652 33.1962 116.597 33.2889C116.544 33.3816 116.426 33.4136 116.333 33.3592C116.333 33.3592 115.059 32.5228 115.112 32.4312Z",
    fill: "url(#paint124_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.363 31.5001C115.363 31.3935 116.884 31.3062 116.884 31.3062C116.991 31.3062 117.078 31.3925 117.078 31.5001C117.078 31.6077 116.992 31.694 116.884 31.694C116.884 31.694 115.363 31.6077 115.363 31.5001Z",
    fill: "url(#paint125_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.112 30.57C115.059 30.4773 116.333 29.642 116.333 29.642C116.426 29.5888 116.544 29.6207 116.597 29.7123C116.651 29.805 116.619 29.9233 116.527 29.9766C116.527 29.9766 115.165 30.6627 115.112 30.57Z",
    fill: "url(#paint126_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.431 29.888C114.339 29.8347 115.025 28.4731 115.025 28.4731C115.078 28.3804 115.196 28.3484 115.289 28.4027C115.382 28.456 115.414 28.5743 115.359 28.667C115.359 28.667 114.523 29.9413 114.431 29.888Z",
    fill: "url(#paint127_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.081 29.3956C113.96 29.3625 115.326 24.0267 115.326 24.0267C115.359 23.9063 115.484 23.8349 115.605 23.8679C115.726 23.901 115.797 24.0256 115.764 24.1471C115.764 24.1471 114.202 29.4286 114.081 29.3956Z",
    fill: "url(#paint128_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.951 29.3882C112.83 29.4202 111.346 24.1163 111.346 24.1163C111.314 23.9948 111.387 23.8712 111.508 23.8393C111.629 23.8073 111.753 23.8808 111.785 24.0012C111.785 24.0012 113.073 29.3562 112.951 29.3882Z",
    fill: "url(#paint129_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.968 29.9455C111.878 30.0339 107.941 26.1823 107.941 26.1823C107.853 26.0928 107.854 25.95 107.944 25.8616C108.033 25.7731 108.176 25.7742 108.264 25.8637C108.264 25.8637 112.057 29.857 111.968 29.9455Z",
    fill: "url(#paint130_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.396 30.9193C111.363 31.0397 106.027 29.6738 106.027 29.6738C105.906 29.6407 105.835 29.5161 105.868 29.3946C105.901 29.2742 106.026 29.2028 106.147 29.2359C106.147 29.2359 111.429 30.7978 111.396 30.9193Z",
    fill: "url(#paint131_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.388 32.0498C111.42 32.1713 106.116 33.6555 106.116 33.6555C105.995 33.6874 105.871 33.6139 105.839 33.4935C105.807 33.3721 105.881 33.2485 106.001 33.2165C106.001 33.2165 111.356 31.9284 111.388 32.0498Z",
    fill: "url(#paint132_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.945 33.0321C112.034 33.1216 108.182 37.0585 108.182 37.0585C108.093 37.1469 107.95 37.1458 107.862 37.0563C107.773 36.9668 107.774 36.8241 107.864 36.7356C107.864 36.7356 111.857 32.9426 111.945 33.0321Z",
    fill: "url(#paint133_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.919 33.6042C113.04 33.6372 111.674 38.973 111.674 38.973C111.641 39.0934 111.516 39.1648 111.395 39.1318C111.274 39.0987 111.203 38.9741 111.236 38.8526C111.236 38.8526 112.798 33.5711 112.919 33.6042Z",
    fill: "url(#paint134_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05 33.6127C114.171 33.5807 115.655 38.8846 115.655 38.8846C115.687 39.0061 115.614 39.1297 115.494 39.1616C115.373 39.1936 115.248 39.1201 115.217 38.9997C115.217 38.9997 113.928 33.6447 114.05 33.6127Z",
    fill: "url(#paint135_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.032 33.0545C115.122 32.966 119.058 36.8177 119.058 36.8177C119.147 36.9072 119.146 37.05 119.056 37.1384C118.967 37.2268 118.824 37.2258 118.736 37.1363C118.736 37.1363 114.943 33.1429 115.032 33.0545Z",
    fill: "url(#paint136_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.604 32.0805C115.637 31.9601 120.973 33.326 120.973 33.326C121.093 33.3591 121.165 33.4837 121.132 33.6052C121.099 33.7267 120.974 33.797 120.853 33.7639C120.853 33.7639 115.571 32.202 115.604 32.0805Z",
    fill: "url(#paint137_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.613 30.9513C115.581 30.8298 120.885 29.3456 120.885 29.3456C121.006 29.3137 121.13 29.3872 121.162 29.5076C121.194 29.629 121.12 29.7526 121 29.7846C121 29.7846 115.645 31.0727 115.613 30.9513Z",
    fill: "url(#paint138_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.054 29.9678C114.966 29.8783 118.818 25.9414 118.818 25.9414C118.907 25.853 119.05 25.854 119.138 25.9435C119.227 26.033 119.226 26.1758 119.136 26.2642C119.136 26.2642 115.143 30.0573 115.054 29.9678Z",
    fill: "url(#paint139_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 27.3415C113.394 27.3415 113.306 19.1939 113.306 19.1939C113.306 19.0874 113.392 19 113.5 19C113.608 19 113.694 19.0863 113.694 19.1939C113.694 19.1939 113.608 27.3415 113.5 27.3415Z",
    fill: "url(#paint140_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.421 27.8988C111.329 27.9521 107.18 20.9392 107.18 20.9392C107.126 20.8465 107.158 20.7283 107.25 20.675C107.343 20.6217 107.461 20.6537 107.514 20.7453C107.514 20.7453 111.513 27.8445 111.42 27.8988H111.421Z",
    fill: "url(#paint141_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.899 29.4214C109.846 29.5141 102.745 25.5154 102.745 25.5154C102.653 25.4621 102.621 25.3438 102.675 25.2511C102.728 25.1584 102.846 25.1265 102.939 25.1808C102.939 25.1808 109.952 29.3297 109.899 29.4224V29.4214Z",
    fill: "url(#paint142_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.342 31.5001C109.342 31.6066 101.194 31.694 101.194 31.694C101.087 31.694 101 31.6077 101 31.5001C101 31.3925 101.086 31.3062 101.194 31.3062C101.194 31.3062 109.342 31.3925 109.342 31.5001Z",
    fill: "url(#paint143_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.899 33.5799C109.952 33.6726 102.939 37.8215 102.939 37.8215C102.847 37.8747 102.728 37.8428 102.675 37.7512C102.622 37.6585 102.654 37.5402 102.745 37.4869C102.745 37.4869 109.844 33.4882 109.899 33.5809V33.5799Z",
    fill: "url(#paint144_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.421 35.1024C111.514 35.1556 107.515 42.2559 107.515 42.2559C107.462 42.3486 107.344 42.3805 107.251 42.3262C107.158 42.2718 107.126 42.1546 107.181 42.062C107.181 42.062 111.33 35.0491 111.422 35.1024H111.421Z",
    fill: "url(#paint145_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 35.6597C113.607 35.6597 113.694 43.8073 113.694 43.8073C113.694 43.9138 113.608 44.0012 113.5 44.0012C113.392 44.0012 113.306 43.9149 113.306 43.8073C113.306 43.8073 113.392 35.6597 113.5 35.6597Z",
    fill: "url(#paint146_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58 35.1024C115.673 35.0491 119.821 42.062 119.821 42.062C119.875 42.1546 119.843 42.2729 119.751 42.3262C119.658 42.3795 119.54 42.3475 119.487 42.2559C119.487 42.2559 115.488 35.1567 115.581 35.1024H115.58Z",
    fill: "url(#paint147_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.102 33.5797C117.156 33.487 124.256 37.4857 124.256 37.4857C124.349 37.539 124.381 37.6572 124.326 37.7499C124.273 37.8426 124.155 37.8746 124.062 37.8203C124.062 37.8203 117.049 33.6713 117.102 33.5786V33.5797Z",
    fill: "url(#paint148_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66 31.5001C117.66 31.3935 125.807 31.3062 125.807 31.3062C125.914 31.3062 126.001 31.3925 126.001 31.5001C126.001 31.6077 125.915 31.694 125.807 31.694C125.807 31.694 117.66 31.6077 117.66 31.5001Z",
    fill: "url(#paint149_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.102 29.4212C117.049 29.3285 124.062 25.1796 124.062 25.1796C124.155 25.1263 124.273 25.1583 124.326 25.2499C124.379 25.3426 124.347 25.4609 124.256 25.5142C124.256 25.5142 117.157 29.5129 117.102 29.4202V29.4212Z",
    fill: "url(#paint150_radial_2002_200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58 27.8988C115.487 27.8455 119.486 20.7453 119.486 20.7453C119.539 20.6526 119.657 20.6206 119.75 20.675C119.843 20.7282 119.875 20.8465 119.82 20.9392C119.82 20.9392 115.671 27.9521 115.579 27.8988H115.58Z",
    fill: "url(#paint151_radial_2002_200)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-153-outside-1_2002_200",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 102,
    height: 34,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 12,
    y: 7,
    width: 102,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32 38L16.32 33.8L27.12 23.6C27.9733 22.8267 28.6 22.1333 29 21.52C29.4 20.9067 29.6667 20.3467 29.8 19.84C29.96 19.3333 30.04 18.8667 30.04 18.44C30.04 17.32 29.6533 16.4667 28.88 15.88C28.1333 15.2667 27.0267 14.96 25.56 14.96C24.3867 14.96 23.2933 15.1867 22.28 15.64C21.2933 16.0933 20.4533 16.8 19.76 17.76L15.04 14.72C16.1067 13.12 17.6 11.8533 19.52 10.92C21.44 9.98667 23.6533 9.52 26.16 9.52C28.24 9.52 30.0533 9.86667 31.6 10.56C33.1733 11.2267 34.3867 12.1733 35.24 13.4C36.12 14.6267 36.56 16.0933 36.56 17.8C36.56 18.7067 36.44 19.6133 36.2 20.52C35.9867 21.4 35.5333 22.3333 34.84 23.32C34.1733 24.3067 33.1867 25.4133 31.88 26.64L22.92 35.08L21.68 32.72L37.48 32.72L37.48 38L16.32 38ZM52.1537 38.48C49.8604 38.48 47.8071 37.92 45.9937 36.8C44.1804 35.6533 42.7537 34 41.7137 31.84C40.6737 29.68 40.1537 27.0667 40.1537 24C40.1537 20.9333 40.6737 18.32 41.7137 16.16C42.7537 14 44.1804 12.36 45.9937 11.24C47.8071 10.0933 49.8604 9.52001 52.1537 9.52001C54.4738 9.52001 56.5271 10.0933 58.3137 11.24C60.1271 12.36 61.5537 14 62.5937 16.16C63.6337 18.32 64.1537 20.9333 64.1537 24C64.1537 27.0667 63.6337 29.68 62.5937 31.84C61.5537 34 60.1271 35.6533 58.3137 36.8C56.5271 37.92 54.4737 38.48 52.1537 38.48ZM52.1537 33C53.2471 33 54.1937 32.6933 54.9937 32.08C55.8204 31.4667 56.4604 30.4933 56.9137 29.16C57.3937 27.8267 57.6337 26.1067 57.6337 24C57.6337 21.8933 57.3937 20.1733 56.9137 18.84C56.4604 17.5067 55.8204 16.5333 54.9937 15.92C54.1937 15.3067 53.2471 15 52.1537 15C51.0871 15 50.1404 15.3067 49.3137 15.92C48.5137 16.5333 47.8737 17.5067 47.3937 18.84C46.9404 20.1733 46.7137 21.8933 46.7137 24C46.7137 26.1067 46.9404 27.8267 47.3937 29.16C47.8737 30.4933 48.5137 31.4667 49.3137 32.08C50.1404 32.6933 51.0871 33 52.1537 33ZM66.9059 38L66.9059 33.8L77.7059 23.6C78.5593 22.8267 79.1859 22.1333 79.5859 21.52C79.9859 20.9067 80.2526 20.3467 80.3859 19.84C80.5459 19.3333 80.6259 18.8667 80.6259 18.44C80.6259 17.32 80.2393 16.4667 79.4659 15.88C78.7193 15.2667 77.6126 14.96 76.1459 14.96C74.9726 14.96 73.8793 15.1867 72.8659 15.64C71.8793 16.0933 71.0393 16.8 70.3459 17.76L65.6259 14.72C66.6926 13.12 68.1859 11.8533 70.1059 10.92C72.0259 9.98668 74.2393 9.52001 76.7459 9.52001C78.8259 9.52001 80.6393 9.86668 82.1859 10.56C83.7593 11.2267 84.9726 12.1733 85.8259 13.4C86.7059 14.6267 87.1459 16.0933 87.1459 17.8C87.1459 18.7067 87.0259 19.6133 86.7859 20.52C86.5726 21.4 86.1193 22.3333 85.4259 23.32C84.7593 24.3067 83.7726 25.4133 82.4659 26.64L73.5059 35.08L72.2659 32.72L88.0659 32.72L88.0659 38L66.9059 38ZM100.26 38.48C98.313 38.48 96.3797 38.2267 94.4597 37.72C92.5663 37.1867 90.9397 36.44 89.5797 35.48L92.1397 30.52C93.2063 31.2933 94.433 31.9067 95.8197 32.36C97.233 32.8133 98.6597 33.04 100.1 33.04C101.726 33.04 103.006 32.72 103.94 32.08C104.873 31.44 105.34 30.5467 105.34 29.4C105.34 28.68 105.153 28.04 104.78 27.48C104.406 26.92 103.74 26.4933 102.78 26.2C101.846 25.9067 100.526 25.76 98.8197 25.76L91.6597 25.76L93.0997 10L110.18 10L110.18 15.2L95.4197 15.2L98.7797 12.24L97.7797 23.48L94.4197 20.52L100.34 20.52C103.113 20.52 105.34 20.9067 107.02 21.68C108.726 22.4267 109.966 23.4533 110.74 24.76C111.513 26.0667 111.9 27.5467 111.9 29.2C111.9 30.8533 111.486 32.3867 110.66 33.8C109.833 35.1867 108.553 36.32 106.82 37.2C105.113 38.0533 102.926 38.48 100.26 38.48Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.32 38L14.32 38L14.32 40L16.32 40L16.32 38ZM16.32 33.8L14.9467 32.346L14.32 32.9379L14.32 33.8L16.32 33.8ZM27.12 23.6L25.777 22.118L25.7617 22.1318L25.7467 22.146L27.12 23.6ZM29 21.52L30.6752 22.6125L30.6752 22.6125L29 21.52ZM29.8 19.84L27.8928 19.2377L27.8782 19.284L27.8658 19.331L29.8 19.84ZM28.88 15.88L27.6105 17.4255L27.6404 17.45L27.6712 17.4734L28.88 15.88ZM22.28 15.64L21.4633 13.8144L21.4541 13.8185L21.445 13.8226L22.28 15.64ZM19.76 17.76L18.677 19.4414L20.2712 20.4682L21.3814 18.931L19.76 17.76ZM15.04 14.72L13.3759 13.6106L12.2488 15.3012L13.957 16.4014L15.04 14.72ZM19.52 10.92L18.6456 9.12126L18.6456 9.12126L19.52 10.92ZM31.6 10.56L30.7819 12.385L30.8007 12.3935L30.8197 12.4015L31.6 10.56ZM35.24 13.4L33.5982 14.5421L33.6065 14.554L33.6149 14.5658L35.24 13.4ZM36.2 20.52L34.2666 20.0082L34.2612 20.0285L34.2563 20.0488L36.2 20.52ZM34.84 23.32L33.2036 22.1701L33.1931 22.1851L33.1828 22.2003L34.84 23.32ZM31.88 26.64L30.5111 25.1819L30.5087 25.1842L31.88 26.64ZM22.92 35.08L21.1495 36.0103L22.3744 38.3415L24.2913 36.5358L22.92 35.08ZM21.68 32.72L21.68 30.72L18.3699 30.72L19.9095 33.6503L21.68 32.72ZM37.48 32.72L39.48 32.72L39.48 30.72L37.48 30.72L37.48 32.72ZM37.48 38L37.48 40L39.48 40L39.48 38L37.48 38ZM18.32 38L18.32 33.8L14.32 33.8L14.32 38L18.32 38ZM17.6932 35.254L28.4932 25.054L25.7467 22.146L14.9467 32.346L17.6932 35.254ZM28.463 25.082C29.3798 24.2512 30.1441 23.4268 30.6752 22.6125L27.3248 20.4275C27.0558 20.8398 26.5669 21.4021 25.777 22.118L28.463 25.082ZM30.6752 22.6125C31.1494 21.8855 31.5294 21.127 31.7341 20.349L27.8658 19.331C27.8039 19.5663 27.6506 19.9279 27.3248 20.4275L30.6752 22.6125ZM31.7072 20.4423C31.9143 19.7865 32.04 19.1139 32.04 18.44L28.04 18.44C28.04 18.6194 28.0057 18.8802 27.8928 19.2377L31.7072 20.4423ZM32.04 18.44C32.04 16.8036 31.4416 15.3129 30.0888 14.2866L27.6712 17.4734C27.865 17.6204 28.04 17.8364 28.04 18.44L32.04 18.44ZM30.1495 14.3345C28.9008 13.3088 27.2603 12.96 25.56 12.96L25.56 16.96C26.793 16.96 27.3659 17.2245 27.6105 17.4255L30.1495 14.3345ZM25.56 12.96C24.1215 12.96 22.748 13.2396 21.4633 13.8144L23.0967 17.4656C23.8386 17.1337 24.6518 16.96 25.56 16.96L25.56 12.96ZM21.445 13.8226C20.1169 14.4329 19.0152 15.3754 18.1386 16.589L21.3814 18.931C21.8915 18.2246 22.4698 17.7538 23.115 17.4574L21.445 13.8226ZM20.843 16.0786L16.123 13.0386L13.957 16.4014L18.677 19.4414L20.843 16.0786ZM16.7041 15.8294C17.5523 14.557 18.7581 13.5142 20.3944 12.7187L18.6456 9.12126C16.4419 10.1925 14.661 11.6829 13.3759 13.6106L16.7041 15.8294ZM20.3944 12.7187C21.9984 11.939 23.9038 11.52 26.16 11.52L26.16 7.52C23.4029 7.52 20.8816 8.03431 18.6456 9.12126L20.3944 12.7187ZM26.16 11.52C28.0205 11.52 29.544 11.8301 30.7819 12.385L32.4181 8.73498C30.5626 7.90321 28.4595 7.52 26.16 7.52L26.16 11.52ZM30.8197 12.4015C32.0967 12.9426 32.9899 13.6678 33.5982 14.5421L36.8818 12.2579C35.7834 10.6789 34.25 9.51073 32.3803 8.7185L30.8197 12.4015ZM33.6149 14.5658C34.22 15.4092 34.56 16.4547 34.56 17.8L38.56 17.8C38.56 15.7319 38.02 13.8441 36.8651 12.2342L33.6149 14.5658ZM34.56 17.8C34.56 18.528 34.4639 19.2628 34.2666 20.0082L38.1334 21.0318C38.4161 19.9639 38.56 18.8853 38.56 17.8L34.56 17.8ZM34.2563 20.0488C34.118 20.6193 33.798 21.3243 33.2036 22.1701L36.4764 24.4699C37.2687 23.3424 37.8553 22.1808 38.1437 20.9912L34.2563 20.0488ZM33.1828 22.2003C32.6298 23.0187 31.758 24.0114 30.5111 25.1819L33.2489 28.0981C34.6154 26.8153 35.7168 25.5946 36.4972 24.4397L33.1828 22.2003ZM30.5087 25.1842L21.5487 33.6242L24.2913 36.5358L33.2513 28.0958L30.5087 25.1842ZM24.6905 34.1497L23.4505 31.7897L19.9095 33.6503L21.1495 36.0103L24.6905 34.1497ZM21.68 34.72L37.48 34.72L37.48 30.72L21.68 30.72L21.68 34.72ZM35.48 32.72L35.48 38L39.48 38L39.48 32.72L35.48 32.72ZM37.48 36L16.32 36L16.32 40L37.48 40L37.48 36ZM45.9937 36.8L44.9248 38.4904L44.9338 38.496L44.9428 38.5016L45.9937 36.8ZM41.7137 31.84L39.9117 32.7076L41.7137 31.84ZM41.7137 16.16L43.5158 17.0276L43.5158 17.0276L41.7137 16.16ZM45.9937 11.24L47.0447 12.9416L47.0537 12.936L47.0627 12.9304L45.9937 11.24ZM58.3137 11.24L57.2335 12.9232L57.2481 12.9325L57.2628 12.9416L58.3137 11.24ZM62.5937 16.16L60.7917 17.0276L60.7917 17.0276L62.5937 16.16ZM62.5937 31.84L60.7917 30.9724L62.5937 31.84ZM58.3137 36.8L59.376 38.4946L59.3827 38.4904L58.3137 36.8ZM54.9937 32.08L53.8021 30.4738L53.7894 30.4832L53.7769 30.4928L54.9937 32.08ZM56.9137 29.16L55.032 28.4826L55.0259 28.4993L55.0202 28.5162L56.9137 29.16ZM56.9137 18.84L55.0202 19.4838L55.0259 19.5007L55.032 19.5174L56.9137 18.84ZM54.9937 15.92L53.7769 17.5072L53.7894 17.5168L53.8021 17.5262L54.9937 15.92ZM49.3137 15.92L48.1221 14.3138L48.1094 14.3232L48.0969 14.3328L49.3137 15.92ZM47.3937 18.84L45.512 18.1626L45.5059 18.1793L45.5002 18.1962L47.3937 18.84ZM47.3937 29.16L45.5002 29.8038L45.5059 29.8207L45.512 29.8374L47.3937 29.16ZM49.3137 32.08L48.0969 33.6672L48.1094 33.6768L48.122 33.6862L49.3137 32.08ZM52.1537 36.48C50.2023 36.48 48.5182 36.0085 47.0447 35.0984L44.9428 38.5016C47.096 39.8315 49.5185 40.48 52.1537 40.48L52.1537 36.48ZM47.0627 35.1096C45.6021 34.186 44.4129 32.8357 43.5157 30.9724L39.9117 32.7076C41.0946 35.1643 42.7587 37.1206 44.9248 38.4904L47.0627 35.1096ZM43.5157 30.9724C42.6372 29.1477 42.1537 26.8474 42.1537 24L38.1537 24C38.1537 27.286 38.7103 30.2123 39.9117 32.7076L43.5157 30.9724ZM42.1537 24C42.1537 21.1526 42.6372 18.8523 43.5158 17.0276L39.9117 15.2924C38.7103 17.7877 38.1537 20.714 38.1537 24L42.1537 24ZM43.5158 17.0276C44.4114 15.1674 45.5956 13.8367 47.0447 12.9416L44.9428 9.53841C42.7652 10.8833 41.0961 12.8326 39.9117 15.2924L43.5158 17.0276ZM47.0627 12.9304C48.5339 12.0001 50.2116 11.52 52.1538 11.52L52.1538 7.52001C49.5092 7.52001 47.0803 8.18662 44.9248 9.54962L47.0627 12.9304ZM52.1538 11.52C54.1277 11.52 55.7989 12.0025 57.2335 12.9232L59.394 9.55683C57.2553 8.18422 54.8198 7.52001 52.1538 7.52001L52.1538 11.52ZM57.2628 12.9416C58.7119 13.8367 59.8961 15.1674 60.7917 17.0276L64.3958 15.2924C63.2114 12.8326 61.5423 10.8834 59.3647 9.53841L57.2628 12.9416ZM60.7917 17.0276C61.6703 18.8523 62.1537 21.1526 62.1537 24L66.1537 24C66.1537 20.714 65.5972 17.7877 64.3958 15.2924L60.7917 17.0276ZM62.1537 24C62.1537 26.8474 61.6703 29.1477 60.7917 30.9724L64.3958 32.7076C65.5972 30.2123 66.1537 27.286 66.1537 24L62.1537 24ZM60.7917 30.9724C59.8946 32.8357 58.7054 34.186 57.2448 35.1096L59.3827 38.4904C61.5488 37.1206 63.2129 35.1643 64.3958 32.7076L60.7917 30.9724ZM57.2515 35.1054C55.8147 36.0061 54.137 36.48 52.1537 36.48L52.1537 40.48C54.8105 40.48 57.2395 39.8339 59.376 38.4946L57.2515 35.1054ZM52.1537 35C53.6475 35 55.0313 34.5714 56.2106 33.6672L53.7769 30.4928C53.3562 30.8153 52.8466 31 52.1537 31L52.1537 35ZM56.1854 33.6862C57.4386 32.7564 58.2701 31.3837 58.8073 29.8038L55.0202 28.5162C54.6507 29.6029 54.2022 30.1769 53.8021 30.4738L56.1854 33.6862ZM58.7955 29.8374C59.382 28.2084 59.6337 26.2362 59.6337 24L55.6337 24C55.6337 25.9772 55.4055 27.445 55.032 28.4826L58.7955 29.8374ZM59.6337 24C59.6337 21.7638 59.382 19.7916 58.7955 18.1626L55.032 19.5174C55.4055 20.5551 55.6337 22.0229 55.6337 24L59.6337 24ZM58.8073 18.1962C58.2701 16.6163 57.4386 15.2436 56.1854 14.3138L53.8021 17.5262C54.2022 17.8231 54.6507 18.3971 55.0202 19.4838L58.8073 18.1962ZM56.2106 14.3328C55.0313 13.4287 53.6475 13 52.1537 13L52.1537 17C52.8466 17 53.3562 17.1847 53.7769 17.5072L56.2106 14.3328ZM52.1537 13C50.6746 13 49.3066 13.435 48.1221 14.3138L50.5054 17.5262C50.9743 17.1784 51.4996 17 52.1537 17L52.1537 13ZM48.0969 14.3328C46.8927 15.256 46.0713 16.6088 45.512 18.1626L49.2755 19.5174C49.6761 18.4046 50.1348 17.8107 50.5306 17.5072L48.0969 14.3328ZM45.5002 18.1962C44.9506 19.8125 44.7137 21.7719 44.7137 24L48.7137 24C48.7137 22.0148 48.9302 20.5341 49.2873 19.4838L45.5002 18.1962ZM44.7137 24C44.7137 26.2281 44.9506 28.1875 45.5002 29.8038L49.2873 28.5162C48.9302 27.4659 48.7137 25.9853 48.7137 24L44.7137 24ZM45.512 29.8374C46.0713 31.3913 46.8927 32.744 48.0969 33.6672L50.5306 30.4928C50.1348 30.1893 49.6761 29.5954 49.2755 28.4826L45.512 29.8374ZM48.122 33.6862C49.3066 34.565 50.6746 35 52.1537 35L52.1537 31C51.4996 31 50.9743 30.8217 50.5054 30.4738L48.122 33.6862ZM66.9059 38L64.9059 38L64.9059 40L66.9059 40L66.9059 38ZM66.9059 33.8L65.5327 32.346L64.9059 32.9379L64.9059 33.8L66.9059 33.8ZM77.7059 23.6L76.3629 22.118L76.3476 22.1319L76.3327 22.146L77.7059 23.6ZM79.5859 21.52L81.2612 22.6125L81.2612 22.6125L79.5859 21.52ZM80.3859 19.84L78.4788 19.2377L78.4641 19.2841L78.4518 19.331L80.3859 19.84ZM79.4659 15.88L78.1965 17.4255L78.2263 17.45L78.2572 17.4734L79.4659 15.88ZM72.8659 15.64L72.0492 13.8144L72.04 13.8185L72.0309 13.8227L72.8659 15.64ZM70.3459 17.76L69.263 19.4414L70.8571 20.4682L71.9673 18.931L70.3459 17.76ZM65.6259 14.72L63.9618 13.6106L62.8348 15.3012L64.543 16.4014L65.6259 14.72ZM70.1059 10.92L69.2316 9.12127L69.2316 9.12127L70.1059 10.92ZM82.1859 10.56L81.3678 12.385L81.3866 12.3935L81.4056 12.4015L82.1859 10.56ZM85.8259 13.4L84.1841 14.5421L84.1924 14.554L84.2009 14.5658L85.8259 13.4ZM86.7859 20.52L84.8525 20.0082L84.8472 20.0285L84.8422 20.0488L86.7859 20.52ZM85.4259 23.32L83.7896 22.1701L83.779 22.1851L83.7688 22.2003L85.4259 23.32ZM82.4659 26.64L81.0971 25.1819L81.0946 25.1842L82.4659 26.64ZM73.5059 35.08L71.7354 36.0103L72.9603 38.3415L74.8773 36.5358L73.5059 35.08ZM72.2659 32.72L72.2659 30.72L68.9558 30.72L70.4954 33.6503L72.2659 32.72ZM88.0659 32.72L90.0659 32.72L90.0659 30.72L88.0659 30.72L88.0659 32.72ZM88.0659 38L88.0659 40L90.0659 40L90.0659 38L88.0659 38ZM68.9059 38L68.9059 33.8L64.9059 33.8L64.9059 38L68.9059 38ZM68.2792 35.254L79.0792 25.054L76.3327 22.146L65.5327 32.346L68.2792 35.254ZM79.049 25.082C79.9657 24.2512 80.7301 23.4269 81.2612 22.6125L77.9107 20.4275C77.6418 20.8398 77.1528 21.4021 76.3629 22.118L79.049 25.082ZM81.2612 22.6125C81.7353 21.8855 82.1153 21.127 82.3201 20.349L78.4518 19.331C78.3899 19.5664 78.2365 19.9279 77.9107 20.4275L81.2612 22.6125ZM82.2931 20.4423C82.5002 19.7865 82.6259 19.1139 82.6259 18.44L78.6259 18.44C78.6259 18.6194 78.5917 18.8802 78.4788 19.2377L82.2931 20.4423ZM82.6259 18.44C82.6259 16.8037 82.0276 15.3129 80.6747 14.2866L78.2572 17.4734C78.451 17.6204 78.6259 17.8364 78.6259 18.44L82.6259 18.44ZM80.7354 14.3346C79.4867 13.3088 77.8462 12.96 76.1459 12.96L76.1459 16.96C77.379 16.96 77.9518 17.2245 78.1965 17.4255L80.7354 14.3346ZM76.1459 12.96C74.7075 12.96 73.334 13.2396 72.0492 13.8144L73.6827 17.4656C74.4246 17.1337 75.2377 16.96 76.1459 16.96L76.1459 12.96ZM72.0309 13.8227C70.7028 14.4329 69.6011 15.3754 68.7246 16.589L71.9673 18.931C72.4774 18.2246 73.0557 17.7538 73.7009 17.4574L72.0309 13.8227ZM71.4289 16.0786L66.7089 13.0386L64.543 16.4014L69.263 19.4414L71.4289 16.0786ZM67.29 15.8294C68.1383 14.5571 69.344 13.5142 70.9803 12.7187L69.2316 9.12127C67.0279 10.1925 65.2469 11.683 63.9618 13.6106L67.29 15.8294ZM70.9803 12.7187C72.5843 11.939 74.4897 11.52 76.7459 11.52L76.7459 7.52001C73.9888 7.52001 71.4676 8.03432 69.2316 9.12127L70.9803 12.7187ZM76.7459 11.52C78.6065 11.52 80.13 11.8301 81.3678 12.385L83.0041 8.73499C81.1486 7.90322 79.0454 7.52001 76.7459 7.52001L76.7459 11.52ZM81.4056 12.4015C82.6826 12.9426 83.5759 13.6678 84.1841 14.5421L87.4677 12.2579C86.3693 10.6789 84.8359 9.51074 82.9662 8.71851L81.4056 12.4015ZM84.2009 14.5658C84.8059 15.4092 85.1459 16.4547 85.1459 17.8L89.1459 17.8C89.1459 15.732 88.606 13.8442 87.451 12.2342L84.2009 14.5658ZM85.1459 17.8C85.1459 18.5281 85.0498 19.2628 84.8525 20.0082L88.7193 21.0318C89.002 19.9639 89.1459 18.8853 89.1459 17.8L85.1459 17.8ZM84.8422 20.0488C84.7039 20.6193 84.3839 21.3243 83.7896 22.1701L87.0623 24.4699C87.8546 23.3424 88.4413 22.1808 88.7296 20.9912L84.8422 20.0488ZM83.7688 22.2003C83.2158 23.0187 82.3439 24.0114 81.0971 25.1819L83.8348 28.0982C85.2013 26.8153 86.3028 25.5946 87.0831 24.4397L83.7688 22.2003ZM81.0946 25.1842L72.1346 33.6242L74.8773 36.5358L83.8373 28.0958L81.0946 25.1842ZM75.2764 34.1498L74.0364 31.7898L70.4954 33.6503L71.7354 36.0103L75.2764 34.1498ZM72.2659 34.72L88.0659 34.72L88.0659 30.72L72.2659 30.72L72.2659 34.72ZM86.0659 32.72L86.0659 38L90.0659 38L90.0659 32.72L86.0659 32.72ZM88.0659 36L66.9059 36L66.9059 40L88.0659 40L88.0659 36ZM94.4597 37.72L93.9174 39.6451L93.9334 39.6496L93.9494 39.6538L94.4597 37.72ZM89.5797 35.48L87.8024 34.5627L87.0039 36.1099L88.4263 37.114L89.5797 35.48ZM92.1397 30.52L93.3136 28.9008L91.4297 27.5349L90.3624 29.6027L92.1397 30.52ZM95.8197 32.36L95.1982 34.261L95.2088 34.2644L95.8197 32.36ZM103.94 32.08L105.071 33.7295L103.94 32.08ZM102.78 26.2L102.18 28.108L102.188 28.1104L102.195 28.1127L102.78 26.2ZM91.6597 25.76L89.668 25.578L89.4686 27.76L91.6597 27.76L91.6597 25.76ZM93.0997 10L93.0997 8.00001L91.2741 8.00001L91.108 9.81803L93.0997 10ZM110.18 10L112.18 10L112.18 8.00002L110.18 8.00001L110.18 10ZM110.18 15.2L110.18 17.2L112.18 17.2L112.18 15.2L110.18 15.2ZM95.4197 15.2L94.0976 13.6993L90.1238 17.2L95.4197 17.2L95.4197 15.2ZM98.7797 12.24L100.772 12.4172L101.216 7.42866L97.4576 10.7393L98.7797 12.24ZM97.7797 23.48L96.4576 24.9807L99.4217 27.592L99.7718 23.6573L97.7797 23.48ZM94.4197 20.52L94.4197 18.52L89.1238 18.52L93.0976 22.0207L94.4197 20.52ZM107.02 21.68L106.183 23.4968L106.201 23.5047L106.218 23.5123L107.02 21.68ZM110.74 24.76L112.461 23.7414L110.74 24.76ZM110.66 33.8L112.378 34.8241L112.382 34.817L112.386 34.8098L110.66 33.8ZM106.82 37.2L107.714 38.9889L107.725 38.9833L106.82 37.2ZM100.26 36.48C98.4887 36.48 96.7268 36.2498 94.97 35.7862L93.9494 39.6538C96.0325 40.2035 98.1373 40.48 100.26 40.48L100.26 36.48ZM95.002 35.7949C93.2886 35.3123 91.8771 34.6536 90.733 33.8461L88.4263 37.114C90.0023 38.2264 91.8441 39.0611 93.9174 39.6451L95.002 35.7949ZM91.3569 36.3973L93.9169 31.4373L90.3624 29.6027L87.8024 34.5627L91.3569 36.3973ZM90.9657 32.1392C92.2178 33.047 93.6349 33.7499 95.1982 34.261L96.4412 30.459C95.2312 30.0634 94.1949 29.5397 93.3136 28.9008L90.9657 32.1392ZM95.2088 34.2644C96.8135 34.7791 98.446 35.04 100.1 35.04L100.1 31.04C98.8734 31.04 97.6526 30.8476 96.4305 30.4556L95.2088 34.2644ZM100.1 35.04C101.961 35.04 103.688 34.6776 105.071 33.7295L102.809 30.4306C102.325 30.7624 101.492 31.04 100.1 31.04L100.1 35.04ZM105.071 33.7295C106.557 32.7107 107.34 31.1957 107.34 29.4L103.34 29.4C103.34 29.8977 103.19 30.1694 102.809 30.4306L105.071 33.7295ZM107.34 29.4C107.34 28.3141 107.052 27.2824 106.444 26.3706L103.116 28.5894C103.254 28.7976 103.34 29.0459 103.34 29.4L107.34 29.4ZM106.444 26.3706C105.715 25.2769 104.557 24.6518 103.364 24.2873L102.195 28.1127C102.923 28.3349 103.098 28.5632 103.116 28.5894L106.444 26.3706ZM103.379 24.292C102.159 23.9086 100.602 23.76 98.8197 23.76L98.8197 27.76C100.45 27.76 101.533 27.9047 102.18 28.108L103.379 24.292ZM98.8197 23.76L91.6597 23.76L91.6597 27.76L98.8197 27.76L98.8197 23.76ZM93.6514 25.942L95.0914 10.182L91.108 9.81803L89.668 25.578L93.6514 25.942ZM93.0997 12L110.18 12L110.18 8.00001L93.0997 8.00001L93.0997 12ZM108.18 10L108.18 15.2L112.18 15.2L112.18 10L108.18 10ZM110.18 13.2L95.4197 13.2L95.4197 17.2L110.18 17.2L110.18 13.2ZM96.7417 16.7007L100.102 13.7407L97.4576 10.7393L94.0976 13.6993L96.7417 16.7007ZM96.7876 12.0628L95.7876 23.3028L99.7718 23.6573L100.772 12.4172L96.7876 12.0628ZM99.1017 21.9793L95.7417 19.0193L93.0976 22.0207L96.4576 24.9807L99.1017 21.9793ZM94.4197 22.52L100.34 22.52L100.34 18.52L94.4197 18.52L94.4197 22.52ZM100.34 22.52C102.956 22.52 104.863 22.8891 106.183 23.4968L107.856 19.8633C105.816 18.9242 103.27 18.52 100.34 18.52L100.34 22.52ZM106.218 23.5123C107.629 24.1297 108.503 24.9081 109.019 25.7787L112.461 23.7414C111.429 21.9986 109.824 20.7237 107.821 19.8477L106.218 23.5123ZM109.019 25.7787C109.593 26.7498 109.9 27.8722 109.9 29.2L113.9 29.2C113.9 27.2212 113.433 25.3836 112.461 23.7414L109.019 25.7787ZM109.9 29.2C109.9 30.5021 109.579 31.6864 108.933 32.7903L112.386 34.8098C113.394 33.087 113.9 31.2046 113.9 29.2L109.9 29.2ZM108.942 32.7759C108.345 33.7768 107.38 34.6726 105.914 35.4167L107.725 38.9833C109.726 37.9674 111.321 36.5965 112.378 34.8241L108.942 32.7759ZM105.925 35.4112C104.584 36.0817 102.732 36.48 100.26 36.48L100.26 40.48C103.121 40.48 105.642 40.025 107.714 38.9889L105.925 35.4112Z",
    fill: "white",
    mask: "url(#path-153-outside-1_2002_200)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0901 37.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0432) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0432) scale(8.9982 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.043) scale(8.9982 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0433) scale(8.99821 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0038 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0038 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0433) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0433) scale(8.99818 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0432) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0432) scale(8.99818 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0038 37.0432) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0038 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0432) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0431) scale(8.9982 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0432) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0037 37.0433) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0432) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0431) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0432) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0431) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0431) scale(8.99819 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0036 37.0433) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0433) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0035 37.0432) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04315) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0901 9.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04318) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04309) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04325) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04321) scale(8.9982 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04312) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04301) scale(8.9982 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04331) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04329) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.0432) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04329) scale(8.99821 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0038 9.04331) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0038 9.04329) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04327) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04325) scale(8.99818 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04316) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04321) scale(8.99818 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0038 9.04318) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0038 9.04309) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04328) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04319) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04329) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04312) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04313) scale(8.9982 8.99819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04318) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04307) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0037 9.04325) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04321) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04313) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04318) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04324) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04308) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04312) scale(8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.0431) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04316) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04314) scale(8.99819 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0036 9.04328) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.0433) scale(8.99821 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.0035 9.04322) scale(8.9982 8.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.609) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0576 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.609) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0576 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0573 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0573 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6088) scale(14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6087) scale(14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0573 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6089) scale(14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0618872 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6088) scale(14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0573 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0574 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0573 14.6089) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6088) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0575 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0573 14.6087) scale(14.9066 14.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5936) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5937) scale(12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5936) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5936) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5936) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5937) scale(12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.053 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5939) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.981 31.5937) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_2002_200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.98 31.5938) scale(12.8505 12.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DECA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B99742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5923C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(37 28)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2002_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(69)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2002_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2002_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(101 19)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default ForwardRef;